import { MarketInfo } from '@/domain/market-info/marketInfo'
import { MarketWalletInfo } from '@/domain/wallet/useMarketWalletInfo'
import { z } from 'zod'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'

export function getMintFormValidator({
  walletInfo,
  marketInfo,
}: {
  walletInfo: MarketWalletInfo
  marketInfo: MarketInfo
}) {
  return z.object({
    isMaxSelected: z.boolean(),
    fromAsset: getFromFieldValidator({ walletInfo, marketInfo }),
    toAsset: AssetInputSchema,
  })
}

export function getFromFieldValidator({
  walletInfo,
  marketInfo,
}: {
  walletInfo: MarketWalletInfo
  marketInfo: MarketInfo
}) {
  return AssetInputSchema.superRefine((field, ctx) => {
    const value = NormalizedUnitNumber(field.value || 0)
    const balance = walletInfo.findWalletBalanceForSymbol(field.symbol)
    const isNativeAsset = marketInfo.nativeAssetInfo.nativeAssetSymbol === field.symbol

    const maxValue = balance

    const issue = value.gt(maxValue)

    if (issue) {
      ctx.addIssue({
        code: 'custom',
        message: isNativeAsset ? 'Not enough HYPE to cover transaction fees' : 'Insufficient balance',
        path: ['value'],
      })
    }
  })
}

export type MintFormSchema = z.input<ReturnType<typeof getMintFormValidator>>
